import { render, staticRenderFns } from "./work_order_information.vue?vue&type=template&id=897220c8&scoped=true&"
import script from "./work_order_information.vue?vue&type=script&lang=js&"
export * from "./work_order_information.vue?vue&type=script&lang=js&"
import style0 from "./work_order_information.vue?vue&type=style&index=0&id=897220c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897220c8",
  null
  
)

export default component.exports